import React from "react";
import { Link } from "react-router-dom";

/**
 * Table of products at or below min stock (low_stock_products from dashboard API).
 * @param {{ data: Array<{ id: number, title: string, sku: string, stock: number, min_stock: number, thumbnail_url: string|null }> }} props
 */
const LowStockProductsTable = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-muted text-center py-4">No low stock products</div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover mb-0">
        <thead>
          <tr>
            <th style={{ width: 50 }}></th>
            <th>Product</th>
            <th>SKU</th>
            <th className="text-end">Stock</th>
            <th className="text-end">Min</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td>
                {row.thumbnail_url ? (
                  <img
                    src={row.thumbnail_url}
                    alt=""
                    style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4 }}
                  />
                ) : (
                  <span className="text-muted">—</span>
                )}
              </td>
              <td>
                <span className="text-dark">{row.title || "—"}</span>
              </td>
              <td>
                <code className="small">{row.sku || "—"}</code>
              </td>
              <td className="text-end">
                <span className={row.stock === 0 ? "text-danger fw-bold" : ""}>
                  {row.stock}
                </span>
              </td>
              <td className="text-end">{row.min_stock ?? "—"}</td>
              <td>
                <Link
                  to={`/products/update-item/${row.id}`}
                  className="btn btn-sm btn-outline-primary"
                >
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LowStockProductsTable;
